export default __webpack_public_path__ + "locales/ar-SA/JavascriptSdk.json?hash=fef066d38168ab9fbc15c0edfde26f63";